import type { WhatsAppTemplateSend } from '../types/whatsapp-template-send.types';
import { buildWhatsAppTemplateSendParams } from '../utils/whatsapp-template-send.util';
import { useCreateWhatsAppTemplateMessage } from './api/whatsapp-template-message-mutation';

/**
 * Sends a standalone template without coupling its form to a CRM timeline.
 * @returns A UI-facing send action and mutation pending state.
 */
export const useSendWhatsAppTemplate = (): WhatsAppTemplateSend => {
  const mutation = useCreateWhatsAppTemplateMessage();
  return {
    isPending: mutation.loading,
    sendTemplate: async (draft) => {
      await mutation.createWhatsAppTemplateMessageAsync(
        buildWhatsAppTemplateSendParams(draft)
      );
    },
  };
};
